import React from "react";
import { useTranslation } from "react-i18next";
import { useColors } from "../../constants/Colors";
import StepWrapper from "./StepWrapper";
import {
  CreateFlatStore,
  USERNAME_MAX_LENGTH,
} from "../../hooks/useCreateFlatStore";

interface Props {
  store: CreateFlatStore;
}

const FlatNameStep: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { textNeutralDefault, textNeutralMuted } = useColors();

  return (
    <StepWrapper
      title={
        t("flats_tab.add_flat.flat_name_title") || "What's the name of your WG?"
      }
      subtitle={
        t("flats_tab.add_flat.flat_name_subtitle") ||
        "Give your flat a memorable name"
      }
    >
      <div>
        <input
          type="text"
          value={store.flatName}
          onChange={(e) => {
            if (e.target.value.length <= USERNAME_MAX_LENGTH) {
              store.setFlatName(e.target.value);
            }
          }}
          placeholder={
            t("flats_tab.add_flat.flat_name_placeholder") ||
            "e.g., Sunny Downtown WG"
          }
          maxLength={USERNAME_MAX_LENGTH}
          autoFocus
          className="cf-input-boxed text-lg"
          style={{ color: textNeutralDefault }}
        />
        <div className="flex justify-end mt-3">
          <span
            className="text-xs tracking-wide"
            style={{
              color:
                store.flatName.length >= USERNAME_MAX_LENGTH
                  ? "#DC362E"
                  : textNeutralMuted,
            }}
          >
            {store.flatName.length}/{USERNAME_MAX_LENGTH}
          </span>
        </div>
      </div>
    </StepWrapper>
  );
};

export default FlatNameStep;
